import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    fallbackLng: 'sk',
    lng: 'sk',
    resources: {
        en: {
            translations: require('./locales/en.json')
        },
        sk: {
            translations: require('./locales/sk.json')
        }
    },
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
        escapeValue: false
    },
    supportedLngs: ['en', 'sk']
});

export default i18n;
